module.exports = __webpack_public_path__ + "static/img/bxzbs.319d5fa5.png";